import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Subject } from 'rxjs';

export interface ISessionData {
  userName: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  token_info?: ISessionToken;
  roles?: string[];
}

export interface ISessionToken {
  when: Date;
  token: string;
  refreshToken: string;
}

const STORAGE_KEY = 'Pharaon_Portal_session';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private session: ISessionData;
  private loaded: boolean;
  private redirectUri: string;

  public session$: BehaviorSubject<ISessionData>;

  constructor(
    private cookieService: CookieService
  ) {
    this.session$ = new BehaviorSubject(null);
  }

  private loadSession(): void {
    if (!this.loaded) {
      const data = this.cookieService.get(STORAGE_KEY);
      this.session = data ? JSON.parse(data) : null;
      this.loaded = true;

      this.session$.next(this.session);

    }
  }

  public hasSession(): boolean {
    this.loadSession();
    return this.session != null;
  }

  public getSession(): ISessionData {
    this.loadSession();
    return this.session;
  }

  private getDomain(): string {
    let domain = location.hostname;
    if (domain.indexOf('.') > -1) {
      const sts = domain.split('.');
      sts.splice(0, 1);
      domain = sts.join('.');
    }

    return domain;
  }

  public setSession(session: ISessionData): void {

    const domain = this.getDomain();

    // expiration in 10 days

    const date = new Date();
    date.setDate(new Date().getDate() + 10);
    const expiration = date.toUTCString();
    console.log(`Setting cookie for domain ${domain}, expiration ${date.toUTCString()}`);

    this.session = session;
    this.cookieService.set(STORAGE_KEY, JSON.stringify(session), date, '/', `${domain}`);
    this.loaded = true;

    this.session$.next(this.session);
  }

  public clearSession(): void {

    if (this.hasSession()) {
      delete this.session;
      this.cookieService.set(STORAGE_KEY, '', 0, '/', `${this.getDomain()}`);
    }
  }

  public getRedirectUri(): string {
    return this.redirectUri;
  }

  public setRedirectUri(value: string): void {
    this.redirectUri = value;
  }
}
